import axios from 'axios'

import firebase from 'firebase/app'
import 'firebase/database'
import "firebase/auth"

const env = process.env
const cohort = env.VUE_APP_COHORT


const firebaseConfig = {
    apiKey: env.VUE_APP_API_KEY,
    authDomain: env.VUE_APP_AUTH_DOMAIN,
    databaseURL: env.VUE_APP_DB_URL,
    projectId: env.VUE_APP_PROJECT_ID,
    storageBucket: env.VUE_APP_STORAGE_BUCKET,
    
};

// const app = initializeApp(firebaseConfig);

// firebase.initializeApp()
// if (!firebase.apps.length) {
firebase.initializeApp(firebaseConfig);
// }


// const auth = getAuth(firebase);
// export const auth = firebase.auth() 

firebase.auth().signInWithEmailAndPassword(env.VUE_APP_EMAIL, env.VUE_APP_AUTH_CODE)
    .then((userCredential) => {
        // Signed in 
        const user = userCredential.user;
        // console.log('Firebase Authenticated:', user);
    })
    .catch((error) => {
        const errorCode = error.code;
        const errorMessage = error.message;
        console.error('Firebase Authentication Error:', errorCode, errorMessage);
    });

// const database = firebase.database();

export const getTracks = async (gene, study = 'PTRC') => {
    if (gene.length === 0) {
        return []
    }

    var path = `gene_tracks/${gene}`
    if (study === 'PCC') {
        path = `gene_tracks_pcc/${gene}`
    }
    const ref = firebase.database().ref(path)
    const series = await ref.once('value')
        .then((snapshot) => {
            return snapshot.val()
        })
    return [gene, series]
}

export const getTrackData = async (track, study = 'PTRC') => {
    if (!track || track.length === 0) {
        return [track, {}]
    }

    var path = `gene_data_by_tracks/${track}`
    if (study === 'PCC') {
        path = `gene_data_by_tracks_pcc/${track}`
    }
    const ref = firebase.database().ref(path)
    const series = await ref.once('value')
        .then((snapshot) => {
            return snapshot.val()
        })
    return [track, series]
}

export const checkAuthentication = async (username, password) => {
    if (!username || username.length === 0) {
        return false
    }

    const path = `user/${username}`
    try {
        // const ref = firebase.database().ref(path)
        const snapshot = await firebase.database().ref(path).once('value');
        if (!snapshot.exists()) {
          throw new Error('Key path does not exist');
        }
        const data = snapshot.val();
        if (data.password === password) {
            return true
        }   else {
            return false
        }
      } catch (error) {
        console.error('Error:', error.message);
        return false;
        // Handle the error
      }
    // const series = await ref.once('value')
    //     .then((snapshot) => {
    //         return snapshot.val()
    //     })
    // return [user, series]
}
